import { Button, Typography } from "@mui/material";
import TableViewIcon from "@mui/icons-material/TableView";
import { buttonColors, colors } from "../../utility/types/constant";

interface ViewMembersBtnProps {
  onClick: () => void;
}

const ViewMembersBtn = (props: ViewMembersBtnProps) => {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      startIcon={<TableViewIcon />}
      sx={{
        borderColor: buttonColors.mainPrimary,
        color: colors.mainPrimary,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.darkGrey,
        }}
      >
        Members
      </Typography>
    </Button>
  );
};

export default ViewMembersBtn;
